"use strict";

exports.__esModule = true;
// Generated by CoffeeScript 1.12.6
var observableConstructor;

observableConstructor = void 0;

var setObservableConstructor = exports.setObservableConstructor = function (constr) {
  return observableConstructor = constr;
};

var getObservableConstructor = exports.getObservableConstructor = function () {
  return observableConstructor;
};